/**
 * Removes all forward slashes ('/') from the given string.
 *
 * @param input - The string to process.
 * @returns The input string without any forward slashes.
 */
export const removeForwardSlashes = (input: string): string => {
  return input.replace(/\//g, '');
};
